import * as React from 'react';

import Envelope140 from './Envelope140';

export const envelope140 = () => <Envelope140 />;

export default {
    title: 'Illustration/Envelope140',
    component: Envelope140,
    parameters: {
        notes: "`import Envelope140 from 'box-ui-elements/es/illustration/Envelope140';`",
    },
};
